<div class="private-legal-page">
  <header class="private-legal-header">
    <a routerLink="/private" class="back-link">
      <i class="pi pi-arrow-left" aria-hidden="true"></i>
      <span>Back to sign in</span>
    </a>
  </header>
  <main>
    @if (legalPage === 'privacy-policy') {
      <app-privacy-policy />
    } @else {
      <app-terms-and-conditions privacyPolicyLink="/private/privacy-policy" />
    }
  </main>
</div>
